// extracted by mini-css-extract-plugin
export var bigImg = "style-mod--big-img--d88b9";
export var bigVideo = "style-mod--big-video--3c126";
export var desktopLayout = "style-mod--desktop-layout--62940";
export var imageItem = "style-mod--image-item--85afa";
export var imageRound = "style-mod--image-round--dd94c";
export var item = "style-mod--item--93b31";
export var mainImg = "style-mod--main-img--4fcb6";
export var mobileLayout = "style-mod--mobile-layout--840c4";
export var mobileSlider = "style-mod--mobile-slider--567ea";
export var productImagesSlider = "style-mod--product-images-slider--4052a";
export var productImg = "style-mod--product-img--54725";
export var productImgVariantB = "style-mod--product-img-variant-b--00d4b";
export var singleSmallImg = "style-mod--single-small-img--60cda";
export var smallImagesBox = "style-mod--small-images-box--eac45";
export var smallVideo = "style-mod--small-video--c194e";
export var swiperDesktop = "style-mod--swiper-desktop--71e14";
export var swiperDesktopNewLayout = "style-mod--swiper-desktop-new-layout--28bad";
export var swiperLoading = "style-mod--swiper-loading--71f8d";
export var swiperMobile = "style-mod--swiper-mobile--1c0de";
export var swiperSlides = "style-mod--swiper-slides--dec01";
export var swiperThumbnails = "style-mod--swiper-thumbnails--823d3";
export var thumbnails = "style-mod--thumbnails--1cd65";